/* Keep background-edge insets distinct from the shared gap between matching surfaces. */
(() => {
  const selector = '#MainContent > .shopify-section > section:is(.cs27,.csbz,.csgb)';
  const heroSelector = '.cs27-hero,.csbz-hero,.csgb-hero';
  const background = (section) => {
    for (let element = section; element; element = element.parentElement) {
      const color = getComputedStyle(element).backgroundColor;
      if (color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)') return color;
    }
    return 'rgb(255, 255, 255)';
  };
  const update = () => {
    const sections = Array.from(document.querySelectorAll(selector));
    const colors = sections.map(background);
    sections.forEach((section, index) => {
      if (section.matches(heroSelector)) {
        section.dataset.cfSpaceEnd = sections[index + 1] && colors[index + 1] !== colors[index] ? 'full' : 'shared';
        return;
      }
      const previous = sections[index - 1];
      section.dataset.cfSpaceStart = !previous || previous.matches(heroSelector) || colors[index - 1] !== colors[index] ? 'full' : 'shared';
      section.dataset.cfSpaceEnd = !sections[index + 1] || colors[index + 1] !== colors[index] ? 'full' : 'shared';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  window.addEventListener('load', update, { once: true });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(update));
  document.addEventListener('shopify:section:reorder', update);
})();
